import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { createPortal } from 'react-dom';
import { useRef, useEffect } from 'react';
import useDisableScroll from '../../hooks/useDisableScroll.js';
import { Overlay as Overlay$1 } from './style/overlay.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["onClick", "bodyPaddingOverride", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Overlay(_ref) {
  var onClick = _ref.onClick,
    bodyPaddingOverride = _ref.bodyPaddingOverride,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var overlayRef = useRef(null);
  useDisableScroll(true, bodyPaddingOverride);
  useEffect(function () {
    if (!overlayRef.current) return;
    overlayRef.current.focus();
    overlayRef.current.style.opacity = '1';
    overlayRef.current.style.visibility = 'visible';
  }, []);
  if (typeof onClick !== 'function' || !children) {
    return null;
  }
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick();
  };
  return /*#__PURE__*/createPortal( /*#__PURE__*/jsx(Overlay$1, _objectSpread(_objectSpread({
    ref: overlayRef,
    className: "popup-open",
    onClick: handleClick
  }, rest), {}, {
    children: children
  })), document.body);
}
Overlay.defaultProps = {
  onClick: null,
  bodyPaddingOverride: null,
  children: null,
  className: null
};

export { Overlay as default };
//# sourceMappingURL=_Overlay.js.map
